import { CoreImageView } from '@core/widgets';
import { AssetsSvgMap, TCommonData, TWidget } from '@libs/types';
import React, { Dispatch, SetStateAction } from 'react';
import { getHref } from '../Image/imageUtils';
import { useInputMask, useSimpleInput } from '../../hooks/useInputs';
import { InputWrapper } from '../UI/Wrapper/InputWrapper';
import styles from './cardInput.module.css';
import { EName } from './types';

type TCardInputNumber = {
    dataTest?: string;
    label?: string;
    value: string;
    errorMessage?: string;
    isError: boolean;
    isShowExpDateState?: boolean;
    isShowExpDateOptions?: boolean;
    isValidCardNumber: boolean;
    tabIndex?: number;
    handleChange: React.ChangeEventHandler;
    setShowExpDateState?: Dispatch<SetStateAction<boolean>>;
    isSimple?: boolean;
};
const CardInputNumber = ({
    dataTest,
    label,
    value,
    isError,
    errorMessage,
    handleChange,
    tabIndex,
    isShowExpDateState = false,
    isShowExpDateOptions = false,
    isValidCardNumber,
    setShowExpDateState,
    isSimple = false,
}: TCardInputNumber) => {
    const isShowShortValue = !isSimple && isShowExpDateState && value;
    const ref = useInputMask('', '', '9999 9999 9999 9999 9999 9999', false, false);
    const useSimpleInputHook = useSimpleInput(value);
    const clearValue = value?.replace(/\s/g, '') ?? '';
    const shortValue = clearValue.slice(-4);

    const rightInputComponent = (
        <button className={styles.inputRightButton} onClick={() => setShowExpDateState?.(true)}>
            <CoreImageView
                src={getHref(AssetsSvgMap.ic_arrow_forward_circle)}
                defaultIcon={getHref(AssetsSvgMap.ic_x)}
                styleProps={{
                    width: 24,
                    height: 24,
                }}
            />
        </button>
    );

    const handleFocus = () => {
        if (isShowExpDateState) {
            setShowExpDateState?.(false);
        }
    };
    const handleBlur = () => {
        if ((isValidCardNumber && !isError) || !value) {
            setShowExpDateState?.(true);
        }
    };
    const isShowRightComponent = !isSimple && isValidCardNumber && !isShowExpDateState && !isError && isShowExpDateOptions;

    return (
        <InputWrapper
            dataTest={dataTest}
            widget={{} as TWidget<TCommonData>}
            labelText={label}
            isFocused={useSimpleInputHook.isFocused}
            isFilled={useSimpleInputHook.isFilled}
            isError={isError}
            errorMessage={errorMessage}
            isLinedInput={!isSimple}
            rightInputComponent={isShowRightComponent ? rightInputComponent : null}
        >
            {isShowShortValue && <input onFocus={handleFocus} readOnly value={`•• ${shortValue}`} />}
            <input
                style={{ display: isShowShortValue ? 'none' : 'block' }}
                ref={ref}
                autoComplete="off"
                type="tel"
                name={EName.CARD_NUMBER}
                value={value}
                onFocus={() => {
                    useSimpleInputHook.handleFocus();
                    if (!isSimple) handleFocus();
                }}
                onBlur={(e) => {
                    useSimpleInputHook.handleBlur(e);
                    if (!isSimple && isShowExpDateOptions) {
                        handleBlur();
                    }
                }}
                onChange={handleChange}
                tabIndex={tabIndex}
            />
        </InputWrapper>
    );
};
export { CardInputNumber };
